import { render, staticRenderFns } from "./RepresentativeForm.vue?vue&type=template&id=6b309d3b&scoped=true"
import script from "./RepresentativeForm.vue?vue&type=script&lang=js"
export * from "./RepresentativeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b309d3b",
  null
  
)

export default component.exports